import { render, staticRenderFns } from "./RetailerCard.vue?vue&type=template&id=b8cbc964&scoped=true&lang=pug"
import script from "./RetailerCard.vue?vue&type=script&lang=js"
export * from "./RetailerCard.vue?vue&type=script&lang=js"
import style0 from "./RetailerCard.vue?vue&type=style&index=0&id=b8cbc964&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cbc964",
  null
  
)

export default component.exports